<template>
  <b-row class="my-3">
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group
        label="Login"
        class="mb-2"
        label-class="head-label"
      ></b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group :state="isInvalid('mobile_number')" label="Mobile Number">
        <b-input-group>
          <b-input-group-prepend is-text id="mobile-prepend"
            >+63</b-input-group-prepend
          >
          <b-form-input
            v-model="form.mobile_number"
            maxlength="10"
            @keypress.native="filterNumeric"
            @keyup.native="trimNumber('mobile_number')"
            :state="isInvalid('mobile_number')"
            placeholder="Enter Mobile Number"
            pattern="[0-9]*"
            inputmode="numeric"
            tabindex="1"
          >
          </b-form-input>
        </b-input-group>
        <b-form-invalid-feedback :state="isInvalid('mobile_number')">
          {{ errorMessage("mobile_number") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :state="isInvalid('pin')" label-class="d-flex justify-content-between">
        <template slot="label">
          <span>MPIN</span>
          <router-link :to="{ name: 'ForgotPin' }" class="float-right">Forgot PIN?</router-link>
        </template>
        <b-form-input
          v-model="form.pin"
          maxlength="4"
          @keypress.native="filterNumeric"
          @keyup.native="trimNumber('pin')"
          :state="isInvalid('pin')"
          type="password"
          placeholder="Enter MPIN"
          pattern="[0-9]*"
          inputmode="numeric"
          tabindex="1"
        >
        </b-form-input>
        <b-form-invalid-feedback :state="isInvalid('pin')">
          {{ errorMessage("pin") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-input type="text" hidden :state="isInvalid('message')"></b-input>
      <b-alert variant="danger" :state="isInvalid('message')">
        {{ errorMessage("message") }}
      </b-alert>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group class="text-center my-3">
        <b-button
          id="proceed-btn"
          variant="primary"
          pill
          class="text-white w-100"
          @click="validateFields"
          :disabled="isLoginEnabled || isLoading"
          tabindex="1"
        >
          Login
        </b-button>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group id="auth-action">
        <span class="text-muted">Don't have an account? </span>
        <router-link class="text-primary" :to="{ name: 'SignUp' }"
          >Sign Up</router-link
        >
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import notification from "@/services/notification";
import "@/plugins/vue-cookies.js";

function initForm() {
  return {
    mobile_number: null,
    pin: null,
    channel: 'website'
  };
}

export default {
  name: "Login",
  data() {
    return {
      form: initForm(),
    };
  },
  computed: {
    ...mapGetters("auth", ["errors", "isLoading"]),
    ...mapGetters("survey", ["surveyDetails"]),
    isLoginEnabled() {
      const requiredFields = Object.keys(this.form).map((field) => {
        return !!this.form[field];
      });
      return requiredFields.includes(false);
    },
    surveyUuid: {
      get() {
        return this.$route.params.uuid ? this.$route.params.uuid : null
      },
      set(uuid) {
        return uuid;
      }
    }
  },
  created() {
    this.$nextTick(() => {
      const element = document.getElementById("auth-container");
      if (element) element.scrollIntoView({ behavior: "smooth" });
    });
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapMutations("auth", ["setErrors"]),
    ...mapActions("auth", ["login"]),
    isNotNumeric(input) {
      return /[^0-9]/g.test(input);
    },
    filterNumeric(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    validateFields() {
      const errors = {};
      const form = this.form;
      const requiredFields = ["mobile_number", "pin"];

      requiredFields.map((field) => {
        if (!form[field])
          errors[field] = `The ${field.replace(/_/g, " ")} field is required.`;
        else if (form[field] && this.isNotNumeric(form[field]))
          errors[field] = "Only numeric characters are allowed.";
        else
          switch (field) {
            case "mobile_number":
              if (form[field].length < 10 || form[field].charAt(0) !== "9")
                errors[field] = "Invalid mobile number format";
              break;
          }
      });

      this.setErrors(errors);

      if (Object.keys(errors).length === 0) this.submitLogin();
      else notification.warning("Oops, cannot register.");
    },
    async submitLogin() {
      this.form['survey_uuid'] = this.surveyUuid;
      await this.login(this.form).then((unileverId) => {
        if (this.errors === null || Object.keys(this.errors).length === 0) {
          if (unileverId) {
            this.$cookies.set('UnileverID', unileverId, '30d');
            this.$root.$emit('reinjectAdobeAnalytics');
          }
          this.$router.push({ name: "Question" });
        }
      });
    },
    trimNumber: function(ref) {
      if (this.form[ref])
        this.form[ref] = this.form[ref].replace(/\D/g, "");
    },
  },
};
</script>
